"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var ActionButtons = function ActionButtons(_ref) {
  var open = _ref.open,
      onEditClicked = _ref.onEditClicked,
      onDeleteClicked = _ref.onDeleteClicked,
      onMouseLeave = _ref.onMouseLeave,
      className = _ref.className,
      hideEditButton = _ref.hideEditButton;

  if (!open) {
    return _react.default.createElement("div", null);
  }

  var getClickHandler = function getClickHandler(callback) {
    return function (evt) {
      evt.stopPropagation();
      callback();
    };
  };

  return _react.default.createElement(_UIButtonGroup.default, {
    className: className,
    onMouseLeave: onMouseLeave
  }, !hideEditButton && _react.default.createElement(_UIButton.default, {
    onClick: getClickHandler(onEditClicked),
    size: "extra-small",
    use: "tertiary",
    "data-selenium-test": "question-and-answer-component-edit-button"
  }, _react.default.createElement(_UIIcon.default, {
    name: "replace"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.edit"
  })), _react.default.createElement(_UIButton.default, {
    size: "extra-small",
    use: "tertiary",
    onClick: getClickHandler(onDeleteClicked)
  }, _react.default.createElement(_UIIcon.default, {
    name: "delete"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.delete"
  })));
};

ActionButtons.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onEditClicked: _propTypes.default.func,
  onDeleteClicked: _propTypes.default.func.isRequired,
  onMouseLeave: _propTypes.default.func.isRequired,
  className: _propTypes.default.string.isRequired,
  hideEditButton: _propTypes.default.bool.isRequired
};
var _default = ActionButtons;
exports.default = _default;
module.exports = exports.default;